module.exports = __webpack_public_path__ + "img/Drop Down Menu - Gray - Selected.97da7dfd.png";